import unicreditLogoFooter from '@/images/clients/unicredit-broker-logo.png'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const Jap: IPartnerSettings = {
  partner: 'Jap',
  deployment: 'Jap',
  hosts: [
    'pojisteni.unicreditleasing.cz'
    // , 'localhost:44470'
  ],
  logo: unicreditLogoFooter,
  market: Market.CZ
}
